<template>
  <layout-full>
    <router-view />
  </layout-full>
</template>

<script>
import LayoutFull from '@core/layouts/layout-full/LayoutFull.vue'

import { trackingMixin } from '../../trackingMixins'

export default {
  components: {
    LayoutFull,
  },
  mixins: [trackingMixin],
}
</script>
